import { useGetBackProcedimenti } from '@framework/api-client/api/backoffice/procedimenti/procedimenti.ts';
import { GetBackProcedimentiTipologia } from '@framework/api-client/api/backoffice/schemas/getBackProcedimentiTipologia.ts';
import { type DatiSessioneUtente } from '@framework/api-client/api/users/schemas/datiSessioneUtente.ts';

export function useDossierMenuItemVisibility(
  currentUser: DatiSessioneUtente | null,
) {
  const enabled = Boolean(process.env.BUILD_FLAGS_DOSSIERS && currentUser);

  const result = useGetBackProcedimenti(
    {
      tipologia: GetBackProcedimentiTipologia.PRATICA,
      page: 1,
      pageSize: 1,
    },
    {
      query: {
        keepPreviousData: true,
        enabled,
      },
    },
  );

  return {
    enabled,
    visible: !!result.data?.data?.totale,
    isLoading: result.isLoading,
    error: result.error,
  };
}
